'use strict';

// import mpro from './mpro.init';

import { doFetch, doXhr } from '../../remote/request';
import Addresses from './ajax-entities/addresses';
import Cart from './ajax-entities/cart';
import Comparer from './ajax-entities/comparer';
import Inventory from './ajax-entities/inventory';
import Wishlist from './ajax-entities/wishlist';
import Section from './ajax-entities/section';

class Ajax {

	constructor() {
		this.doXhr = doXhr;
		this.doFetch = doFetch;
		this.addresses = new Addresses;
		this.cart = new Cart;
		this.comparer = new Comparer;
		this.inventory = new Inventory;
		this.wishlist = new Wishlist;
		this.section = new Section;
	}
}

// Export to mpro module
mpro.ajax = new Ajax;

export default mpro;
